// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"555":"6603fe7d","787":"a5c7fe1a"}[chunkId] + ".chunk.js";
};